<template>
    <div class="app">
        <TheSidebar
            v-if="authed"
        />
        <main
            :class="{'isAuthed': authed}"
            class="main">
            <transition
                name="page"
                mode="out-in"
            >
                <router-view/>
            </transition>
        </main>

        <portal-target name="endOfPage"/>
        <portal-target name="mediaPortal"/>
    </div>
</template>

<script>
import TheSidebar from './components/layout/TheSidebar.vue';

export default {
    name: 'App',
    components: {
        TheSidebar,
    },
    metaInfo: {
        title: 'Alde - Products',
    },
    data: () => ({
        menuOpen: false,
    }),
    computed: {
        authed() {
            return this.$store.getters['auth/token'];
        },
    },
};
</script>

<style lang="postcss" scoped>
.page-enter-active {
    transition: var(--normalTrans);
}
.page-leave-active {
    transition: var(--fastTrans);
}
.page-enter,
.page-leave-to {
    opacity: 0;
}
.isAuthed {
    padding: 50px 70px;
    margin-left: 300px;
    @media (--smallDesktop) {
        padding: 50px 40px;
        margin-left: 260px;
    }
    @media (--laptop) {
        padding: 40px;
        margin-left: 200px;
    }
}
</style>
